import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';
import styles from './InvoiceActivity.css';

class InvoiceActivity extends React.Component {
  render() {
    const { invoiceDetail } = this.props;
    return (
      <div className={`row ${styles['invoice-wrapper']}`}>
        <div className={`col-md-12 ${styles['invoice-activity']}`}>
          <div className={`col-md-12 ${styles['invoice-activity-container']}`}>
            INVOICE ACTIVITY
          </div>
          <div className={`col-md-12 ${styles['invoice-activity-list']}`}>
            <span className="glyphicon glyphicon-list-alt" />
            &nbsp;&nbsp; At{' '}
            {moment(invoiceDetail.created_at).format('D/MM/YYYY')} Invoice #
            {invoiceDetail.invoice_no} created for{' '}
            {rupiah(invoiceDetail.total_collected)}
            <div className={`col-md-12 ${styles['invoice-activity-note']}`}>
              {invoiceDetail.payment_note ? 'Note:' : ''}
            </div>
            <div
              className={`col-md-12 ${styles['invoice-activity-note-value']}`}
            >
              <i>{invoiceDetail.payment_note}</i>
            </div>
          </div>
          <div className={`col-md-12 ${styles['invoice-activity-list']}`}>
            <span className="glyphicon glyphicon-envelope" />
            &nbsp;&nbsp; At{' '}
            {moment(invoiceDetail.created_at).format('D/MM/YYYY')} Invoice #
            {invoiceDetail.invoice_no} send to {invoiceDetail.customer_email}
          </div>
          <div className={`col-md-12 ${styles['invoice-activity-list']}`}>
            {invoiceDetail.payment_records.length > 0 &&
              invoiceDetail.payment_records.map((paymentRecord, idx) => {
                return (
                  <div key={idx}>
                    {invoiceDetail.invoice_deposit_amount ===
                    paymentRecord.amount_received ? (
                      <div>
                        <span className="glyphicon glyphicon-tags" />
                        &nbsp;&nbsp; At{' '}
                        {moment(paymentRecord.payment_date).format(
                          'D/MM/YYYY'
                        )}{' '}
                        Down Payment of {rupiah(paymentRecord.amount_received)}{' '}
                        is received.
                      </div>
                    ) : (
                      <div>
                        <span className="glyphicon glyphicon-tags" />
                        &nbsp;&nbsp; At{' '}
                        {moment(paymentRecord.payment_date).format(
                          'D/MM/YYYY'
                        )}{' '}
                        payment of {rupiah(paymentRecord.amount_received)} is
                        received via{' '}
                        {this._paymentTypeFormatter(paymentRecord.payment_type)}
                        .
                      </div>
                    )}

                    {paymentRecord.note && (
                      <div>
                        <div
                          className={`col-md-12 ${
                            styles['invoice-activity-note']
                          }`}
                        >
                          Note:
                        </div>
                        <div
                          className={`col-md-12 ${
                            styles['invoice-activity-note-value']
                          }`}
                        >
                          <i>{paymentRecord.note}</i>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          {invoiceDetail.payment_refunds.length > 0 && (
            <div className={`col-md-12 ${styles['invoice-activity-list']}`}>
              <span className="glyphicon glyphicon-list-alt" />
              &nbsp;&nbsp; At{' '}
              {moment(invoiceDetail.payment_refunds[0].created_at).format(
                'D/MM/YYYY'
              )}{' '}
              Invoice #{invoiceDetail.invoice_no} is cancelled with refund of{' '}
              {rupiah(invoiceDetail.total_collected)}
            </div>
          )}
        </div>
      </div>
    );
  }

  _paymentTypeFormatter = paymentType => {
    return paymentType.split('_').join(' ');
  };
}

InvoiceActivity.propTypes = {
  invoiceDetail: PropTypes.object,
};

export default InvoiceActivity;
